import { FC } from 'react'

import { Props } from './props'
import { Wrapper } from './styles'

export const Item: FC<Props> = ({ children, ...props }) => <Wrapper {...props}>{children}</Wrapper>
